import { _ as _sfc_main } from "./VaAccordion.vue_vue_type_script_lang-a8b9c6ba.mjs";
import { openBlock, createElementBlock, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaAccordion_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-accordion" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const _VaAccordion = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaAccordion as _
};
//# sourceMappingURL=VaAccordion-8b42eda0.mjs.map
